module.exports = __webpack_public_path__ + "img/activity-1-en.5f2266bf.png";